import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../api";
import { useOktaAuth } from "@okta/okta-react";
import toastMessages from "../helpers/toastMessage";

async function fetchSourceIp() {
  const response = await fetch("https://api.ipify.org?format=json");
  const data = await response.json();
  return data?.ip;
}

function useSaveAdditionalClinician() {
  const { authState } = useOktaAuth();

  async function saveAdditionalClinician(data: { values: any, orderId: number }) {
    const { values, orderId } = data;
    const additionalClinicians = values?.additionalClinician ?? [];
    const filteredClinicians = additionalClinicians.filter(
      (clinician: any) => clinician?.status === undefined
    );

    const sourceIp = await fetchSourceIp();
    const payload = {
      data: filteredClinicians.map((clinician: any) => ({
        firstName: clinician?.firstName,
        lastName: clinician?.lastName,
        fax: clinician?.fax,
        npi: clinician?.npi,
        email: clinician?.email,
        orderId, 
      })),
      SourceIpAddress: sourceIp,
    };

    return axiosInstance.post(`/v1/additional-clinicians`, payload, {
      headers: {
        Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
      },
    });
  }

  return useMutation({
    mutationKey: ["saveClinician"],
    mutationFn: saveAdditionalClinician,
    onSuccess: () => {
      toastMessages.success("Additional clinicians updated successfully.");
    },
    onError: () => toastMessages.error("Failed to save additional clinicians."),
  });
}

export default useSaveAdditionalClinician;
